import React, { useState, useEffect, useRef } from "react";
import { Link } from 'react-scroll';

export default function NavBar() {
  const [sticky, setSticky] = useState(false);
  const ref = useRef(null)

  useEffect(() => {
    const handleScroll = () => {
      setSticky(window.scrollY > (window.innerHeight - ref.current.clientHeight));
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return (
    <div ref={ref} style={sticky ? styles.navSticky : styles.nav}>
      <div class="flex w-4/12 mx-auto justify-between">
        <div>
          <Link to="home" smooth={true} offset={-75}>
            <button class="p-3">
              <span class="text-primary uppercase text-xs">Home</span>
            </button>
          </Link>
        </div>
        <div>
          <Link to="about" smooth={true} offset={-75}>
            <button class="p-3">
              <span class="text-primary uppercase text-xs">About</span>
            </button>
          </Link>
        </div>
        <div>
          <Link to="services" smooth={true} offset={-75}>
            <button class="p-3">
              <span class="text-primary uppercase text-xs">Services</span>
            </button>
          </Link>
        </div>
        <div>
          <Link to="contact" smooth={true} offset={-75}>
            <button class="p-3">
              <span class="text-primary uppercase text-xs">Contact</span>
            </button>
          </Link>
        </div>
      </div>
    </div>
  );
}

let styles = {
  nav: {
    backgroundColor: 'white',
    color: 'white',
    position: 'absolute',
    bottom: 0,
    width: '100%',
    height: '80px',
    textAlign: 'center',
    paddingTop: '9px',
    paddingBottom: '9px',
    fontFamily: "Montserrat",
    zIndex: 10,
    display: 'flex',
    alignItems: 'center',
  },
  navSticky: {
    backgroundColor: 'white',
    color: 'white',
    bottom: 0,
    width: '100%',
    height: '80px',
    textAlign: 'center',
    paddingTop: '9px',
    paddingBottom: '9px',
    fontFamily: "Montserrat",
    position: 'fixed',
    top: 0,
    zIndex: 20,
    display: 'flex',
    alignItems: 'center',
  }
};